import React from 'react';
import PropTypes from 'prop-types';

import WithLang from '../../i18n/WithLang';
import styles from './maxLengthExceeded.module.css';

const MaxLengthExceeded = ({ maxLength, inputLength = null, translate }) => (
  <p><span className={`icon--info ${styles.ok}`} />
    {`${translate('textInput.maxLength')} ${maxLength} ${inputLength ? `(${inputLength})` : ''}`}
  </p>
);

const {
  func, number
} = PropTypes;

MaxLengthExceeded.propTypes = {
  maxLength: number.isRequired,
  inputLength: number,
  translate: func.isRequired
};

MaxLengthExceeded.defaultProps = {
  inputLength: null
};

export default WithLang(MaxLengthExceeded);
